const CURRENCY_OPTIONS = ['PLN', 'EUR', 'USD'];

const CURRENCY_SYMBOLS = {
    PLN: 'zł',
    EUR: '€',
    USD: '$'
}

const LOCALE = 'pl-PL'
const formatters = {};

function formatCurrency(value, currencyCode = 'PLN'){
    if (!formatters[currencyCode]){
        formatters[currencyCode] = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: currencyCode})
    }
    return formatters[currencyCode].format(value)
}

export { CURRENCY_OPTIONS, CURRENCY_SYMBOLS, formatCurrency }